import React from 'react'
import HomeHeader from './home-header'
import HomeLeft from './home-left'
import HomeMiddle from './home-middle'
import HomeRight from './home-right'
import './index.less'

export default function Home() {
  return (
    <div className="light-home">
      <HomeHeader />
      <div className="light-home-body">
        <HomeLeft />
        <HomeMiddle />
        <HomeRight />
      </div>
    </div>
  )
}
